export default{
    'cargaMasiva.DescargarArchivo':'Download Template',
    'cargaMasiva.CargarArchivo':'Upload Template',
    'cargaMasiva.Errores':'Error loading template',
    'cargaMasiva.Error':'Error',
    'cargaMasiva.Identificador':'Identifier',
    'cargaMasiva.Bodega':'Store',
    'cargaMasiva.TipoDocumento':'Document type'
}